import styled, { css } from "styled-components";

export const alignCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Grow = styled.div`
  flex-grow: 1;
`;
